<template>
  <div class="question-group">
    <ui-box
      class="question-group__title"
      :class="{
        'py-12px': $media.desktop,
        'py-24px': $media.widescreen
      }"
    >
      <h4 class="is-size-6 has-text-weight-bold">{{ title }}</h4>
    </ui-box>

    <ui-box
      :class="{
        'pt-12px': $media.desktop,
        'pt-24px': $media.widescreen,
        'pb-24px': $media.desktop,
        'pb-32px': $media.widescreen
      }"
    >
      <question v-for="question in questions" :key="question.uniqueKey" :question="question" :language="language"></question>
    </ui-box>
  </div>
</template>
<script>
import UiBox from '@/components/ui/box'
import question from './question'

export default {
  components: { question, UiBox },
  props: {
    title: String,
    questions: Array,
    language: String
  }
}
</script>

<style lang="scss" scoped>
.question-group {
  &__title {
    background-color: $grey-lighter;
  }
}
</style>